import type { Tracklist } from "@api/tracklists/types";
import { Row } from "@components/Layout";
import useI18n from "@contexts/I18nProvider/hooks/useI18n";
import { formatPostTotalTime } from "@src/app/utils";
import { BsDot } from "solid-icons/bs";
import { FiHeadphones } from "solid-icons/fi";
import { type JSX, type VoidComponent, createMemo } from "solid-js";
import { DataBadgeWrapper } from "./styled";

const ProgrammeDataBadge: VoidComponent<{ tracklist: Tracklist; fontSize?: JSX.CSSProperties["font-size"] }> = (
	props,
) => {
	const { t } = useI18n();
	const totalTime = createMemo(() => formatPostTotalTime(props.tracklist.tracks.reduce((p, c) => p + c.length, 0)));
	return (
		<DataBadgeWrapper alignItems="center" gap="10px" w="max-content" padding="10px" fontSize={props.fontSize}>
			<Row gap="5px" alignItems="center" w="fit-content">
				<FiHeadphones />
				{totalTime()}
			</Row>
			<BsDot />
			<Row>{t("app.programme.tracks", props.tracklist.tracks.length)}</Row>
		</DataBadgeWrapper>
	);
};
export default ProgrammeDataBadge;
